export const PRIVATE_SAVED_DASHBOARDS_KEY = 'pulse5';
export const PUBLIC_SAVED_DASHBOARDS_KEY = 'pulse5-public';
export const PULSE4_DASHBOARDS_KEY = 'pulse4';

export const tabList = [{
  key: PRIVATE_SAVED_DASHBOARDS_KEY,
  label: 'My Dashboards',
}, {
  key: PUBLIC_SAVED_DASHBOARDS_KEY,
  label: 'Public Dashboards',
}];

export const DataSourceMapping = {
  all: 'All',
  ai: 'Ad',
  ei: 'Video',
  app: 'ECO'
};

export const getDataModelDropdownItems = () => {
  return [
    {
      key: 'all',
      label: DataSourceMapping.all,
    },
    {
      key: 'ei',
      label: DataSourceMapping.ei,
    },
    {
      key: 'ai',
      label: DataSourceMapping.ai,
    },
    {
      key: 'app',
      label: DataSourceMapping.app
    }
  ];
};

export const getBaseUrlByProduct = (productName: string) => {
  const product = (productName.toUpperCase() || 'EI') as keyof typeof window['conviva']['modules'];
  const moduleConfig = window.conviva.modules[product];
  return moduleConfig.baseUrl;
}

export const shouldShowShareInList = () => {
  return true;
}

export const shouldShowEditInList = (isPublic, dashboardData, userProfile) => {
  if (!isPublic) {
    return true;
  }
  else {
    if (dashboardData.createdById === userProfile.profile_id) {
      return true;
    }
    return false;
  }
}

export const shouldShowDeleteInList = (isPublic, dashboardData, userProfile) => {
  if (!isPublic) {
    return true;
  }
  else {
    if (dashboardData.createdById === userProfile.profile_id) {
      return true;
    }
    return false;
  }
}